import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const ExternalReportSlice = createSlice({
  name: "ExternalReportSlice",
  initialState: {},
  reducers: {},
});
export const addExternalReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const {
        type = "",
        report_date = "",
        report_year = "",
        provider = "",
      } = payload || {};

      // Ensure `report_year` is included in the payload only if `type` is "yearly"
      const requestBody: any = {
        type,
        report_date,
        provider,
      };

      if (type === "yearly") {
        requestBody.report_year = report_year;
      }

      // Make the API request with the constructed body
      const res = await api.post(API_URL.EXTERNAL_REPORTS.ADD, requestBody);
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListExternalReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        type = "",
        report_date = "",
        current = 1,
        page_size = 10,
        report_year = "",
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `type=${type}`,
        `report_date=${report_date}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      // Add report_year only if type is "yearly"
      if (type === "yearly") {
        actionParts.push(`report_year=${report_year}`);
      }

      // Join query parts
      const action = `?${actionParts.join("&")}`;

      // Make the API call
      const response = await api.get(API_URL.EXTERNAL_REPORTS.LIST + action);

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteExternalReports =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(API_URL.EXTERNAL_REPORTS.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default ExternalReportSlice.reducer;
